import {SlotGlobalKey} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SlotLocation';
import {IValue} from '@mintdata/mint-kit/api/types/Value';

export const EMPTY_SLOT_FORMULA:SlotFormula = '';

export type FormulaString = string;
export type SlotFormula = FormulaString | IValue;

export type SlotDependencies = Map<SlotGlobalKey, SlotDependency>

export interface SlotDependency
{
    type:SlotDependencyType;
}

export enum SlotDependencyType
{
    Value = 'Value',
    Status = 'Status',
    All = 'All',
    LocationHash = 'LocationHash',
    ViewportInfo = 'ViewportInfo'
}
